<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>{{ data.message }}</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close cdkFocusInitial (click)="onNoClick()">
    No
  </button>
  <button mat-button mat-dialog-close (click)="onYesClick()">Ok</button>
</div>
